@if (items && items.length) {
  <div class="content-highlight block-container" [style.color]="textColor">
    @if (sliderEnabled ? !swiperComponent()?.swiper?.isBeginning || !swiperComponent()?.swiper?.isEnd || title : title) {
      <div class="content-highlight__header" [class.empty-title]="!title">
        <h4 class="content-highlight__title" [rtl]="langcode">
          {{ title }}
        </h4>
        @if ((!swiperComponent()?.swiper?.isBeginning || !swiperComponent()?.swiper?.isEnd) && sliderEnabled) {
          <div class="content-highlight__arrows" [style.color]="textColor">
            <button class="button button--icon button--transparent" mat-icon-button aria-label="Previous" [disabled]="swiperComponent()?.swiper?.isBeginning" (click)="swiperComponent()?.swiper?.slidePrev()">
              <lib-icon icon="arrow-left"></lib-icon>
            </button>
            <button class="button button--icon button--transparent" mat-icon-button aria-label="Next" [disabled]="swiperComponent()?.swiper?.isEnd" (click)="swiperComponent()?.swiper?.slideNext()">
              <lib-icon icon="arrow-right"></lib-icon>
            </button>
          </div>
        }
      </div>
    }
    <div class="col-12 px-0 w-100" [ngClass]="mobileCardStyle">
      @if (sliderEnabled) {
        <lib-swiper class="content-swiper" [slides]="items" [options]="swiperOptions()">
          <ng-template swiperContent let-item="item">
            <ng-container *ngTemplateOutlet="slideTmp; context: { item: item }"></ng-container>
          </ng-template>
        </lib-swiper>
      } @else {
        <div class="content-highlight__list-view">
          <div class="content-highlight__row cards-base-grid">
            @for (item of items; track item) {
              <div class="content-highlight__slide">
                <ng-container *ngTemplateOutlet="slideTmp; context: { item: item }"></ng-container>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}


<ng-template let-item="item" #slideTmp>
  @if (mobileCardStyle === mobileCardStyleTypes.SMALL_CARD) {
    <lib-small-card
      [data]="item"
      (cardClick)="navigate($event, item)">
    </lib-small-card>
  }
  @switch (item.bundle) {
    @case (bundleTypes.CLASS) {
      <lib-class-card
        [data]="item"
        (cardClick)="navigate($event, item)">
      </lib-class-card>
    }
    @case (bundleTypes.COURSE) {
      <lib-course-card
        [data]="item"
        [showDetailsButton]="courseDetailsEnabled"
        [paymentEnabled]="isPaymentEnabled"
        (cardClick)="navigate($event, item)"
        (buttonClick)="navigate($event, item)"
        (detailsClick)="openDetails.emit(item)">
      </lib-course-card>
    }
    @case (bundleTypes.MODULE) {
      <lib-course-card
        [data]="item"
        (cardClick)="navigate($event, item)"
        (buttonClick)="navigate($event, item)">
      </lib-course-card>
    }
    @default {
      <lib-lesson-card
        [data]="item"
        (cardClick)="navigate($event, item)">
      </lib-lesson-card>
    }
  }
</ng-template>
